<ngx-extended-pdf-viewer [src]="'../../../assets/images/new/copy-emails-guide.pdf'" height="75vh"
    [useBrowserLocale]="true"></ngx-extended-pdf-viewer>